<template>
  <div class="bb-service-provider">
    <transition name="fade" appear>
      <loader-fly v-if="loaderRun"/>
    </transition>
    <ContactServiceProvider @loader="setLoader"/>
    <div class="bb-service-provider-right">
      <div class="bb-service-provider-right-header">
        <div class="bb-service-provider-right-header-menu">
          <div class="bb-service-provider-right-header-menu-item"
               :class="{'bb-service-provider-right-header-menu-item_active': activeMenuItem === menuItem.id}"
               v-for="menuItem in rightPanelMenu"
               :key="menuItem.id"
               @click="activeMenuItem = menuItem.id">
            {{ menuItem.title }}
          </div>
        </div>
      </div>
      <div v-if="serviceId !== 'new'">
        <ServiceProviderHistory @loader="setLoader"/>
      </div>
    </div>
  </div>
</template>

<script>
import ContactServiceProvider from '../ContactCard/ContactServiceProvider/ContactServiceProvider'
import ServiceProviderHistory from './ServiceProviderHistory/ServiceProviderHistory'
import LoaderFly from '@/components/Main/Loaders/LoaderFly'

export default {
  name: 'ServiceProvider',
  components: {ServiceProviderHistory, ContactServiceProvider, LoaderFly},
  data () {
    return {
      rightPanelMenu: [
        {
          id: 0,
          title: 'History',
          component: ServiceProviderHistory
        }
      ],
      activeMenuItem: 0,
      loaderRun: false
    }
  },
  computed: {
    serviceId () {
      return this.$route.params.id
    }
  },
  methods: {
    setLoader (value) {
      this.loaderRun = value
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";
@import "../../../../../sass/mixins";

.bb-service-provider {
  @include global-font;
  position: relative;
  display: flex;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  z-index: 1;

  &-right {
    position: relative;
    display: flex;
    flex-direction: column;
    width: calc(100% - 422px);
    max-height: calc(100% + 20px);
    border-radius: 5px;
    background-color: $color-white;
    z-index: 1;
    margin: -10px  -20px;

    &_active {
      z-index: 99;
    }

    &-header {

      &-menu {
        display: flex;
        align-items: flex-end;
        border-bottom: 1px solid $color-alabaster;

        &-item {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 18px 24px;
          font-weight: 600;
          font-size: 15px;
          line-height: 18px;
          color: $color-accent;
          margin-right: 32px;
          cursor: pointer;

          &:after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            border-radius: 3px 4px 0 0;
            background-color: $color-accent;
            transition: 0.3s;
            opacity: 0;
            height: 0;
          }

          &_active {
            pointer-events: none;

            &:after {
              opacity: 1;
              height: 3px;
            }
          }

          &:hover {
            &:after {
              background-color: $color-accent-hover;
              opacity: 1;
              height: 3px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ServiceProvider/ServiceProvider.vue